import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Params,Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { accounting } from 'accounting';


@Component({
  selector: 'list-permit',
  templateUrl: './permit-approval-list.component.html',
  styleUrls: ['./permit-approval-list.component.css']
})
export class PermitApprovalListComponent implements OnInit {

  @Input('ctrlData') ctrlData: any;
  permits: any = [];
  statuses: any = [];
  flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagAP: 1, flagPN: 1,flagPT: 1, flagST: 1, flagDS: 1 };
  ranks = { flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4,flagAP: 5,flagPN: 6, flagPT: 7, flagST: 8, flagDS: 9 };
  sortLabels = { flagAN: "AccountNumber", flagNM: "Name", flagLU: "LeadUser", flagCT: "CarrierType", flagAP: "ApplicationNumber",flagPN: "PermitNumber" ,flagPT: "PermitType", flagST: "Status", flagDS: "DateSubmitted" };
  direction: boolean = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 9;
  isLoading: Boolean = false;
  message: string = 'Loading  permit applications, please wait...';
  statuses1: any = [];
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 10;
  PermitStatus2: number;
  PermitStatus4: number;
  PermitStatus6: number;
  PermitStatus8: number;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  selectedItems: any = [];
  dropdownSettings: any = {};
  carrierNumber: string;
  carrierName: string;
  permitNumber: String;
  isDef: boolean = true;
  currentUserName : string = '';
  filterStatus : any;

  constructor(private msg: ToastrService, private activeRoute: ActivatedRoute, private applicationService: ApplicationService, private statusService: StatusService, private authWebService: AuthWebService, public utility: UtilityServiceService, private router: Router) {}

    ngOnInit() {
      if(this.router.url.indexOf('approved') > 0){       
        this.filterStatus = 51;       
      }
      else if(this.router.url.indexOf('printed') > 0){  
        this.filterStatus = 75;   
      }

      this.currentUserName = this.authWebService.userData.User.UserName;
      this.loadConfigStatuses();
      this.initKeyword();
      this.loadStatuses();
      this.InitMultiselect();
  }

  unLockApplication(data)
  {
   
    if(environment.authWebApi.userData.Roles.find(p=>p.Code=='ADMIN') ){     
      this.setApplicationLock(data,false);
    }
    else
    {
      this.msg.warning('Please contact Manager/Team Lead to unlock this application.','Not Authorized!');
    }
  }

  setApplicationLock(application,lockStatus)
  {
    application.isLocked = lockStatus;    
    application.isLockedBy = lockStatus? this.authWebService.userData.User.UserName : "";
    
    this.applicationService.putApplication(application).subscribe((r)=>
    {
      if(lockStatus)
      {
        this.msg.info("Application Locked By '" + application.isLockedBy + "'", "Lock Application", { timeOut: 1000 });
      }
      else
      {
        this.msg.info("Application Unlocked", "UnLock Application", { timeOut: 1000 });
      }
    }, error=>{
     
    });
  }

  onProcessClick = (ctrlAction, data) => {

    this.ctrlData.ctrlAction = ctrlAction;
    //this.ctrlData.currentActive = 2;
    this.ctrlData.data = data
    this.utility.carrierId = data.carrier_id;
    this.utility.permitAppId = data.id;    

    this.router.navigate(['/carrier/process/permit/application', data.id]);

  }

  loadStatuses = () => {
    this.statusService.statusesDDL(2).subscribe((result:any) => {
       let activeStatuses : any = result.filter(x => x.is_active == true);      
      this.statuses = activeStatuses.map(row => {
        return { id: row.id, desc: row.desc };
      });
      // this.statuses.sort((a,b) => a.sort_order > b.sort_order ? 1 : -1 &&  a.group_code > b.group_code ? 1 : -1 &&  a.id > b.id ? 1 : -1)
      this.statuses.sort((a,b) => a.sort_order > b.sort_order ? 1 : -1 &&  a.desc > b.desc ? 1 : -1)
      this.loadAccounts(this.currentPage, this.pageSize);
    });

  }

  InitMultiselect() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'desc',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: this.ShowFilter,
      maxHeight: 210,
      closeDropDownOnSelection: false
    };
  }

  onItemSelect(item: any) {
  }
  onSelectAll(items: any) {
  }
  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { allowSearchFilter: this.ShowFilter });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 2 });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
    }
  }

  onDeSelect(item: any) {
  }

  onReset = () => {
    this.selectedItems = [];
    this.carrierNumber = null;
    this.carrierName = null;
    this.initKeyword();
    this.utility.page = 1;
    this.message = 'Loading  permit applications, please wait...';
    this.loadAccounts(this.utility.page, this.pageSize, this.isDef=true);
  }
  setSearchKeywords = () => {
    this.keyword.AccountNumber = (this.carrierNumber) ? this.carrierNumber : "All";
    this.keyword.Suffix = (this.carrierName) ? this.carrierName : "All";
    this.keyword.permitNumber=(this.permitNumber) ? this.permitNumber : "All";
    this.keyword.Statuses = (this.selectedItems) ? this.selectedItems.map(status => { return status.id; }) : [];
  }
  initKeyword = () => {
    this.keyword = { Suffix: "All", AccountNumber: "All", PermitNumber: "All", Statuses: [] };
    if(this.filterStatus != null && this.filterStatus != undefined)
    {
      this.keyword.Statuses = [this.filterStatus];
    }
    else{
    this.retrieveDefaultStatuses();
    }
  }

  loadConfigStatuses()
  {
    if (this.authWebService.userData) {
      this.PermitStatus2 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus2").Value;  // submitted
      this.PermitStatus4 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus4").Value;  // approved
      this.PermitStatus6 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus6").Value;  // application and permit fee quote has been accepted
      this.PermitStatus8 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus8").Value;  // permit has been printed
    }
  }

  isSearchable = () => {
    return (this.carrierNumber != null || this.permitNumber != null ||this.carrierName != null || this.selectedItems.length > 0);
  }

  retrieveDefaultStatuses = () => {
    
      this.keyword.Statuses = [this.PermitStatus2, 74]; // Submitted, STATUS CODE 74 = Submitted - Compliance
    
  }

  checkKey(event){
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 13) {
      this.onSearch();
      return;
    }
  }

  onSearch = () => {
    if (!this.isSearchable()) {
      this.msg.info("Please provide at least one filter value.", "Permit Approval Search", { timeOut: 5000 });
      return;
    }
    this.setSearchKeywords();
    this.utility.page = 1;
    this.message = "Searching for carrier accounts, please wait...";
    this.loadAccounts(this.utility.page, this.pageSize, this.isDef = false);
  }

  onChange = () => {
    this.loadAccounts(this.utility.page = 1, this.pageSize, this.isDef);
  }

  loadAccounts = (page: number = 1, pageSize: number = 10, isDef: boolean = true) => {
    this.isLoading = true; //console.log('keyword: ', this.keyword)    
    this.applicationService.searchApplications(this.keyword, page, pageSize,isDef,this.rankCtrl,this.direction).subscribe((result:any) => {
      this.permits = result.Items;
      
      let permitsArray: any;
      this.permits.forEach(permt => {
        if (permt.number_of_permits > 1) {
          permitsArray = permt.Permits.filter(x => x.RegNumber != null)
          permt.number_of_permits = permitsArray.length;
        
        }
      });

      // this.permits = result.Items;     
     
      this.count = result.Count;
      this.onExcuteSort(this.rankCtrl);

      this.isLoading = false;
      this.isEmpty = false;

    }, error => {
      this.permits = [];
      this.count = 0;
      this.isEmpty = true;
      //console.log('Error occured: ' + error);
      this.isLoading = false;
    });
    this.utility.page = page;

  }

  formatCurrency(value) {
    return accounting.formatMoney(value, 'R', 2, ' ', '.');
}

  cleanUpNumberOfPermits(cleanPermits) {
      let noPermits: any;
      cleanPermits.forEach(element => {
      //   if (element.number_of_permits > 1) {
      //     numPermits = element.vehicle.filter(x => x != null);
      //     if (numPermits.length > 0) {
      //       element.number_of_permits = numPermits.length;
      //     } else {
      //       element.number_of_permits = 1;
      //     }
      //   }
      });
      this.permits = cleanPermits
      //console.log(this.permits);
  }

  onSort(rank: number) {
    this.direction = !this.direction;
    this.rankCtrl = rank;
    this.onExcuteSort(rank);
  }

  onResetFlags() {
    this.flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagAP:1,flagPN: 1, flagPT: 1, flagST: 1, flagDS: 1 };  }

  onExcuteSort(rank: number) {
    this.onResetFlags();
    let sort = (this.direction) ? 3 : 2;
    this.criteria = null;
    switch (rank) {
      case this.ranks.flagAN: {
        this.criteria = this.sortLabels.flagAN;
        this.flags.flagAN = sort;
        break;
      }
      case this.ranks.flagNM: {
        this.criteria = this.sortLabels.flagNM;
        this.flags.flagNM = sort;
        break;
      }
      case this.ranks.flagLU: {
        this.criteria = this.sortLabels.flagLU;
        this.flags.flagLU = sort;
        break;
      }
      case this.ranks.flagCT: {
        this.criteria = this.sortLabels.flagCT;
        this.flags.flagCT = sort;
        break;
      }
      case this.ranks.flagAP: {
        this.criteria = this.sortLabels.flagAP;
        this.flags.flagAP = sort;
        break;
      }
      case this.ranks.flagPN: {
        this.criteria = this.sortLabels.flagAP;
        this.flags.flagAP = sort;
        break;
      }
      case this.ranks.flagPT: {
        this.criteria = this.sortLabels.flagPT;
        this.flags.flagPT = sort;
        break;
      }
      case this.ranks.flagST: {
        this.criteria = this.sortLabels.flagST;
        this.flags.flagST = sort;
        break;
      }
      default: {
        this.criteria = this.sortLabels.flagDS;
        this.flags.flagDS = sort;
        break;
      }
    }

  }


  onNextOrPrevious(page: number = 1) {
    this.message = 'Loading  permit applications, please wait...';
    this.loadAccounts(page, this.pageSize, this.isDef);
    this.currentPage = page;
    return page;
  }

  onProcessPrint=(data)=>{    
    this.ctrlData.currentActive = 4;
  this.ctrlData.data = data;
  }

  isPrintable = (statusId: number) => {
    var canPrint : boolean;
    canPrint = (this.PermitStatus4 === statusId) || (statusId === this.PermitStatus8);
    
    return (canPrint);
  }
}

